import { TOGGLE_SIDEBAR } from '../../actions/sidebar/sidebarAction';

const initialState = {
  isSidebarOpen: true,
};

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return { ...state, isSidebarOpen: !state.isSidebarOpen };
    default:
      return state;
  }
};

export default sidebarReducer;
